import { RenderWhen, StringWithCopy } from "@components";
import Typography from "@components/typography/Typography";
import SampleLink from "@modules/graph-explorer/components/common/links/SampleLink";
import { isSha1Hash } from "@modules/samples_cloud/utils";

type Props = {
  filename?: string;
  sha1: string;
  classification: string;
};

const FileName = ({ filename, sha1, classification }: Props) => {
  const isHash = isSha1Hash(filename ?? "");
  const name = filename && !isHash ? filename : sha1;
  return (
    <div className="m-right-2">
      <StringWithCopy reverse value={name}>
        <SampleLink
          className={`threat-link--${classification.toLowerCase()} overflow-ellipsis`}
          label={name}
          hash={sha1}
        />
      </StringWithCopy>
      <RenderWhen condition={name !== sha1}>
        <Typography variant="body4">{sha1}</Typography>
      </RenderWhen>
    </div>
  );
};

export default FileName;
